/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

declare var LogglyTracker: any;

@Injectable()
export class LogService {

  private loggly: any = null;
  constructor() {
    try {
      this.loggly = new LogglyTracker();
    }
    catch (e) {
      this.loggly = [];
    }
  }

  /**
   * Initialize the service - gets called from APP_INITIALIZER because services don't have ngOnInit
   * @param token
   */
  init(token: string) {
    this.loggly.push({
      logglyKey: token,
      sendConsoleErrors: true,
      tag: 'siftrock-client'
    });
  }

  error(error: any) {
    if (error instanceof HttpErrorResponse) {
      // only want non 401's and 403's because those will already have been logged from the back-end
      if (error.status != 401 && error.status != 403) {
        this.loggly.push({ name: error.name, message: error.message, level: 'error', status: error.status, url: error.url });
      }
    }
    else if (error instanceof TypeError) {
      this.loggly.push({ name: error.name, message: error.message, level: 'error', stack: error.stack });
    }
    else if (error instanceof Error) {
      this.loggly.push({ name: error.name, message: error.message, level: 'error', stack: error.stack });
    }
    else if (typeof error === 'string') {
      this.loggly.push({ message: error, level: 'error' });
    }
    else {
      this.loggly.push({ message: error });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/services/log.service.ts